import BaseMapper from './base-mapper';

class DeviceMapper extends BaseMapper {}

export default new DeviceMapper({
  path: '/devices',
});



// WEBPACK FOOTER //
// ./src/mappers/device-mapper.js